import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import "./header.css"
import { useState } from "react"
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap"

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default function Header({ menuLinks, siteTitle }) {
  const [collapsed, setCollapsed] = useState(true)

  const toggleNavbar = () => setCollapsed(!collapsed)

  return (
    <header className="mb-4">
      <Navbar
        light
        expand="md"
        style={{ backgroundColor: "#ED4337", borderBottom: "4px solid" }}
      >
        <NavbarBrand
          href="#"
          onClick={() => document.getElementById("Home").click()}
          className="mr-auto"
          style={{
            fontSize: "38px",
            fontWeight: "500",
          }}
        >
          {siteTitle}
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse isOpen={!collapsed} navbar>
          <Nav className="ml-auto" navbar style={{ paddingTop: "0.8rem" }}>
            {menuLinks.map(link => (
              <NavItem key={link.name}>
                <NavLink
                  href="#"
                  style={{ textAlign: "center", fontSize: "24px" }}
                  onClick={() => document.getElementById(link.name).click()}
                >
                  {link.name}
                </NavLink>
                <Link
                  id={link.name}
                  to={link.link}
                  style={{ display: "none" }}
                />
              </NavItem>
            ))}
          </Nav>
        </Collapse>
      </Navbar>
    </header>
  )
}
